import _jsx from "@babel/runtime/helpers/jsx";
var _Glyphicon;
/**
 *  The OwnerDistance component takes an owner object and returns a
 *  glyphicon along with copy describing a name and associated distance.
 *
 */

import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { Glyphicon } from 'reaxl';
import OwnerWebsiteCTA from '../OwnerWebsiteCTA/OwnerWebsiteCTA';
function OwnerDistance(_ref) {
  let {
    analyticsData,
    className = 'text-size-300 text-subdued-lightest text-size-200',
    owner,
    displayOwnerName,
    showIcon = true,
    showOwnerDistance = true,
    uiContext = 'inventory',
    ...rest
  } = _ref;
  const {
    distanceFromSearch,
    name = '',
    website = {},
    isVirtual
  } = owner;
  displayOwnerName = displayOwnerName || name;
  const isDistanceViewable = (!!distanceFromSearch || distanceFromSearch === 0) && !isVirtual && showOwnerDistance;
  let ownerTitle = '';
  if (uiContext !== 'owner') {
    if (website?.href) {
      ownerTitle = /*#__PURE__*/_jsx(OwnerWebsiteCTA, {
        href: website.href,
        label: displayOwnerName,
        analyticsData: analyticsData,
        uiContext: "link"
      });
    } else {
      ownerTitle = displayOwnerName;
    }
  }
  const distanceLabel = distanceFromSearch + ' mi. away';
  const distanceLabelClasses = clsx('text-normal', {
    'padding-left-1': uiContext !== 'owner'
  });
  return isDistanceViewable || ownerTitle ? /*#__PURE__*/React.createElement("div", Object.assign({
    key: "ownerDistance",
    "data-cmp": "ownerDistance",
    className: className
  }, rest), showIcon && (_Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "map-marker",
    className: "text-gray-base"
  }))), ownerTitle, isDistanceViewable && !showIcon && /*#__PURE__*/_jsx("span", {
    className: distanceLabelClasses
  }, void 0, distanceLabel), isDistanceViewable && showIcon && /*#__PURE__*/_jsx("span", {
    className: distanceLabelClasses
  }, void 0, ` (${distanceLabel})`)) : null;
}
export default OwnerDistance;